import { render, staticRenderFns } from "./ViewDailyTestQuestions.vue?vue&type=template&id=2ca18560&scoped=true"
import script from "./ViewDailyTestQuestions.vue?vue&type=script&lang=js"
export * from "./ViewDailyTestQuestions.vue?vue&type=script&lang=js"
import style0 from "./ViewDailyTestQuestions.vue?vue&type=style&index=0&id=2ca18560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca18560",
  null
  
)

export default component.exports